module.exports = __webpack_public_path__ + "img/3b4f3c0658adb7315c593d5494fd26f9.de18db98.png";